import { useState } from 'react';

import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

import CallApi from '../../API_Utils/APIUtil/CallApi';
import {
  downloadBulkSampleFile,
  getError,
  normalizeBulkUploadValidationResult,
  validator
} from '../../clientUtils';
import SingleStepUploader from '../../Components/BulkUploader/SingleStepUploader';
import { FILE_TYPE_ATTRIBUTE } from '../../constants';

const CommonSingleStepUploader = ({
  submitButtonText,
  title,
  sampleEndpoint,
  invoiceType,
  validationEndpoint,
  submitEndpoint,
  selectionKey,
  header,
  steps,
  currentStep,
  onNext,
  openGroup,
  uploadDescription,
  sampleDownloadFileName,
  customSampleDownload
}) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [savedFile, setSavedFile] = useState();
  const naviagate = useNavigate();
  const requestParams = invoiceType ? { invoice_type: invoiceType } : undefined;

  const handleSampleDownload = async () => {
    if (customSampleDownload) {
      await customSampleDownload();
      return;
    }

    await downloadBulkSampleFile(
      sampleEndpoint,
      requestParams,
      sampleDownloadFileName || `${title}-sample.csv`
    );
  };

  const SKUListUploadProps = {
    title,
    description:
      uploadDescription || 'Please upload the list of SKUs (in CSV format with max file size of 5 MB)',
    sampleDownloadText: 'Download Sample file',
    sampleDownloadFileName,
    onSampleDownload: handleSampleDownload,
    accept: FILE_TYPE_ATTRIBUTE.csv,
    files,
    validator,
    uploadingText: 'Validating...',
    onUpload: async (file) => {
      setSavedFile(file);
      await CallApi(
        validationEndpoint,
        requestParams,
        { file },
        setValidating,
        (res) => setFiles([normalizeBulkUploadValidationResult(res)]),
        (res) => message.error(getError(res))
      );
    },
    onRemove: async () => {
      setFiles([]);
      message.success('File deleted successfully!');
    }
  };
  const uploaderProps = {
    message: '',
    items: [SKUListUploadProps]
  };

  const isSubmitDisabled = () => {
    if (validating) return true;
    if (!files || files.length < 1) return true;
    if (files[0]?.summary?.failure > 0) return true;
    return false;
  };

  const handleSubmit = () => {
    CallApi(
      submitEndpoint,
      requestParams,
      { file: savedFile },
      setSubmitting,
      () => message.success('File submitted successfully'),
      (res) => message.error(getError(res)),
      () => {
        if (!onNext) {
          // Let the success toast render before reloading the page.
          setTimeout(() => naviagate(0), 1000);
        } else {
          onNext();
        }
      }
    );
  };

  return (
    <SingleStepUploader
      currentStep={currentStep}
      loading={loading}
      onSubmit={handleSubmit}
      openGroup={openGroup}
      selectionKey={selectionKey}
      steps={steps}
      submitButtonText={submitButtonText}
      submitDisabled={isSubmitDisabled()}
      submitting={submitting}
      title={header}
      uploaderProps={uploaderProps}
    />
  );
};

export default CommonSingleStepUploader;
